import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';
import ClipLoader from 'react-spinners/ClipLoader';

import _masterSlideLoader from '../utilities/masterSlideLoader';
import companySaftyEditSchema, {
  schemaForSafetyDoc,
  schemaOtherIndustryLicense,
} from '../utilities/validationSchemas/companySaftyEdit';
import dialogLoader from '../utilities/dialogLoader';
import {
  validationByJoi_New,
  validationByJoi,
} from '../utilities/commonValidation';
import { messageUtility } from '../utilities/messageUtility';
import {
  isNullOrEmpty,
  safariOnIosCheck,
  deleteControlCode,
  isNullOrUndefinedOrEmptyStr,
} from '../utilities/stringUtil';
import {
  FlagIndicator,
  HEADER_CONSTANTS,
  DIALOG_STATUS,
  EXISTANCE_EXCLUSION_FLAG,
  EXISTANCE_FLAG,
  EXCLUDE_KEY_COMPANY_BRANCH_PERMISSIONS,
} from '../utilities/constants';
import { GreenService } from '../services/GreenFile'; // 労安項目情報API
import SessionStorageService from '../services/utilities/SessionStorageService';
import { CompanyService } from '../services/Companies';
import { AttachDocuments } from '../services/AttachDocuments';
import { PartnerCompanyBranchSafetyForm } from '../components/forms/PartnerCompanyBranchSafetyForm';
import { PartnerNaviList } from '../components/list/PartnerNaviList';
import { onceAsyncRequest } from '../utilities/commonUtil';
import PartnerCompanyBranchService from '../services/PartnerCompanyBranch';
import {
  PRESENCE,
  EXCLUSION,
  INSURANCE_STATUS,
  HEALTH_INSURANCE_FLAG,
  PENSION_FLAG,
  EMPLOYMENT_INSURANCE_FLAG,
  CONSTRUCTION_INDUSTRY_PERMISSION_FLAG,
  createErrorMessageList,
  isConstructionIndustryPermissionStatus,
  showPrefectureInput,
  getCompanyBranchPermissionsErrorMsg,
  deleteCompanyBranchPermissionsErrorMsgByIndex,
  showRegionalDevelopmentBureau,
  filterComboBoxHealthInsuranceTypeWhenExist,
  filterComboBoxPensionInsuranceTypeWhenExist,
  cleanupBeforeUpdateUtil,
  checkExistData,
  hasRequestUserFixList,
  showAskForFlagUpdateDialog,
  filterComboBoxHealthInsuranceTypeWhenExclusion,
  setInputOrSelectionForType,
  filterComboBoxPensionInsuranceTypeWhenExclusion,
  setInputOrSelectionForReasonExclusion,
  concatOtherIndustryPermissionGroupsSubmit,
  isHasOtherIndustryPermission,
  concatOtherIndustryPermissionDeleteIds,
  getParamCommonCompanyBranchPermission,
  getAllCommonCompanyBranchPermissionId,
  getRequiredColumnsOtherIndustryPermissionChange,
} from '../utilities/companySafetyUtil';
import ConfirmationSafetyDocItemDialog from '../components/worker/dialog/ConfirmationSafetyDocItemDialog';
import Style from '../styles/componentStyle/worker/insuranceInfo/insuranceInfo.scss';
import {
  attachDocumentDeleteState,
  attachDocumentCompanyUploadState,
  attachDocumentCompanyDownload,
} from '../utilities/attachDocumentUtil';
import { getPartnerCompanyName } from '../utilities/partnerCompanyConfirmUtil';
import { MasterPageHeader } from '../components/PageHeader';
import { CloseEditView } from '../components/CloseEditView';
import { FormInformationDialog } from '../components/FormInformationDialog';
import { convertDate } from '../utilities/validateDateUtil';
import { RegionalDevelopmentBureauxService } from '../services/RegionalDevelopmentBureaux'; // 振興局情報API
import {
  AttentionBox,
  showFixedDataAnnouncementDialog,
  showUserFixApprovalDialog,
  ApprovalDialog,
} from '../components/UserFixDataAttentionComponents';
import Information from '../components/modals/common/Information';
import { DeleteCompanyLicenseConfirmDialog } from '../components/modals/DeleteCompanyLicenseConfirmDialog';

const DEFAULT_REQUIRE_COLUMN = [
  'construction_industry_permission_flag',
  'company_detail.other_industry_permission_flag',
];

/**
 * 会社情報確認 画面  労務安全項目 タブ
 * 画面遷移
 *  - 協力会社管理者でログイン > 会社情報確認 > 労務安全項目 > 編集ボタン
 */
export class PartnerCompanyBranchSafetyEdit extends React.Component {
  constructor(props) {
    super(props);

    // IEのみファイルアップロードするとconsoleにTypeMismatchErrorエラーが表示される問題の対策
    window.onunhandledrejection = function(event) {
      event.preventDefault();
    };

    this.selectedCompanyId = SessionStorageService.getSessionSelectedPartnerCompanyId();
    this.selectedPartnerCompanyBranchId = SessionStorageService.getSelectedPartnerCompanyBranchSafetyId();

    if (!this.selectedPartnerCompanyBranchId) {
      window.location.replace('/error-permission');
    }

    this.state = {
      selectedCompanyName: '',
      errorMessages: {}, // エラーメッセージ
      validate: {
        invalid: false, // 入力内容エラー
      },
      requiredInput: {
        // 必須入力項目
        columns: DEFAULT_REQUIRE_COLUMN, // 必須項目名
        total: 0, // 必須総数
        count: 0, // 入力数
      },
      checkboxList: {
        construct_permit_source_types: {}, // 許可元区分名
        construct_permit_types: {}, // 建設許可区分名
        insurance_statuses: {}, // 健康保険、年金保険、雇用保険の加入状態
      },

      comboboxList: {
        construct_permit_industry_types: {}, // 許可業種名
        health_insurance_exclusions: {}, // 健康保険_適用除外理由
        health_insurance_types: {}, // 健康保険種類
        pension_insurance_exclusions: {}, // 年金保険適用除外理由
        pension_insurance_types: {}, // 年金保険種類名称
        employment_insurance_exclusions: {}, // 雇用保険適用除外理由
      },

      documentCodes: [],
      bureaux: [], // 振興局（APIから取得）

      partnerCompanyBranch: {
        name: '',
        id: '',
        block_flag: '',
      },

      formValues: {
        // 代表者情報
        company_detail: {
          delegate_name: '', // 代表者名
          delegate_name_kana: '', // 代表者名フリガナ
          delegate_post: '', // 代表者名役職
          construction_industry_permission_flag: EXISTANCE_FLAG.NOEXIST.VALUE, // 建設業許可有無フラグ
          other_industry_permission_flag: '',
        },
        old_company_permission_documents: [],

        // 許可情報
        company_branch_permissions: [],

        // 許可情報削除対象を保持する配列
        delete_company_branch_permission_document_ids: [],
        delete_company_branch_permission_ids: [],
        delete_company_branch_permission_group_ids: [],

        other_company_branch_permission_groups: [],

        // 保険情報
        company_branch_insurance: {
          health_insurance_flag: '', // 健康保険_加入状況
          ccus_health_insurance_reason_exclusion_code: '', // 社会保険適用外理由コード_健保
          health_insurance_reason_exclusion: '', // 健康保険_適用除外理由
          health_insurance_uninsured_reason: '', // 健康保険_(未加入の)理由
          health_insurance_type_code: '', // 健康保険_健康保険種類コード
          health_insurance_type: '', // 健康保険_健康保険種類
          health_insurance_name_insurer: '', // 健康保険_健康保険者名称
          health_insurance_office_symbol: '', // 健康保険_事業所整理記号
          health_insurance_office_number: '', // 健康保険_事業所整理番号
          pension_flag: '', // 年金保険_加入状況
          ccus_pension_reason_exclusion_code: '', // 社会保険適用外理由コード_年金
          pension_reason_exclusion: '', // 年金保険_適用除外理由
          pension_uninsured_reason: '', // 年金保険_(未加入の)理由
          pension_type_code: '', // 年金保険_年金種類コード
          pension_type: '', // 年金保険_年金保険種類名称
          pension_office_symbol: '', // 年金保険_事業所整理記号
          pension_office_number: '', // 年金保険_事業所番号
          employment_insurance_flag: '', // 雇用保険_加入状況
          ccus_employment_insurance_reason_exclusion_code: '', // 社会保険適用外理由コード_雇用
          employment_insurance_reason_exclusion: '', // 雇用保険_適用除外理由
          employment_insurance_uninsured_reason: '', // 雇用保険_(未加入の)理由
          employment_insurance_insurance_number: '', // 雇用保険_労働保険番号
          other_subscription_flag: '0', // その他退職金共済加入状況
        },
      },

      // ccusフォーム
      ccusformValues: {
        // 代表者情報
        ccus_jigyousyas: {
          daihyousya_name: '', // 代表者名
          daihyousya_kana_name: '', // 代表者名フリガナ
          construct_permit_availability: '', // 建設業許可有無フラグ
          construct_permit_number_type: '', // 許可元区分名「空白/00～47」
          jigyousya_construct_permit_source_type: '', // 許可元区分名「0,1,2」
          construct_permit_number_type_id: '', // 建設許可区分名
          business_name: '', // 許可業種名
          construct_permit_number_year: '', // 許可番号年度
          construct_permit_number: '', // 許可番号固有番号
          start_date: '', // 許可年月日
          health_ins_status: '', // 健康保険加入状況
          health_ins_exclusion: '', // 健康保険適用除外理由
          health_ins_name: '', // 健康保険者名称
          health_ins_jigyousyo_symbol: '', // 健康保険事業所整理記号
          health_ins_jigyousyo_number: '', // 健康保険事業所番号
          pension_ins_status: '', // 年金保険加入状況
          pension_ins_exclusion: '', // 年金保険適用除外理由
          pension_ins_jigyousyo_symbol: '', // ccus年金保険事業所整理記号
          pension_ins_jigyousyo_number: '', // ccus年金保険事業所番号
          employment_ins_status: '', // ccus雇用保険加入状況
          employment_ins_exclusion: '', // ccus雇用保険適用除外理由
          employment_ins_number: '', // ccus雇用保険労働保険番号
          workmans_comp_ins_status: '', // ccus労災保険特別加入状況
          workmans_comp_ins_number: '', // ccus労災保険特別加入労働保険番号
          workmans_comp_ins_reference_number: '', // ccus労災保険特別加入整理番号
          kentaikyo_status: '', // ccus建退共制度加入状況
          kentaikyo_contractor_number: '', // ccus建退共契約者番号
          chutaikyo_status: '', // ccus中退共制度加入状況
          chutaikyo_contractor_number: '', // ccus中退共契約者番号
        },
      },
      dialogStatus: DIALOG_STATUS.disabled.id,
      confirmationModalSafetyDocItem: {
        // 安全書類項目用バリデート
        errorPropertyList: [],
      },
      requestUserFixListByHealthInsurance: [],
      requestUserFixListByPensionInsurance: [],
      requestUserFixListByEmploymentInsurance: [],
      userFixApproval: false,
      initialLoadingSocialInsuranceFlag: {
        // 編集画面読み込み時の各種健康保険の加入状況。既存データ対応のための青枠の文字出力のため使用
        healthInsuranceFlag: '',
        pensionFlag: '',
        employmentInsuranceFlag: '',
      },
      visibleDialogFlag: false,
      visibleConfirmDeleteDialog: false,
      deleteCompanyBranchPermissionsExistGreenFile: [],
      expirationCompany: {},
    };

    this.saftyEditSchema = companySaftyEditSchema();
    this.targetNumberType = [
      'permitted_source_section',
      'construction_industry_permission_section',
    ];
    this.clearFlagList = [
      'construction_industry_permission_flag',
      'health_insurance_flag',
      'health_insurance_type',
      'pension_flag',
      'employment_insurance_flag',
    ];
    this.companyBranchInsuranceKeys = {
      health_insurance_flag: 'health_insurance_office_number',
      pension_flag: 'pension_office_number',
      employment_insurance_flag: 'employment_insurance_insurance_number',
    };
    this.formToCcusNameMap = {
      company_detail: {
        delegate_name: 'daihyousya_name', // 代表者
        delegate_name_kana: 'daihyousya_kana_name', // 代表者名フリガナ
      },
      company_branch_permissions: {
        permitted_source_section: 'jigyousya_construct_permit_source_type', // 許可元区分名
        construction_industry_permission_section:
          'construct_permit_number_type_id', // 建設許可区分名
        authorized_industry_names: 'business_name', // 許可業種名
        permission_number_l: 'construct_permit_number_year', // 許可番号年度
        permission_number_r: 'construct_permit_number', // 許可番号固有番号
        license_date: 'start_date', // 許可年月日
      },
      company_branch_insurance: {
        health_insurance_flag: 'health_ins_status', // 健康保険加入状況
        health_insurance_reason_exclusion: 'health_ins_exclusion', // 健康保険適用除外理由
        health_insurance_name_insurer: 'health_ins_name', // 健康保険者名称
        health_insurance_office_symbol: 'health_ins_jigyousyo_symbol', // 健康保険事業所整理記号
        health_insurance_office_number: 'health_ins_jigyousyo_number', // 健康保険事業所番号
        pension_flag: 'pension_ins_status', // 年金保険加入状況
        pension_reason_exclusion: 'pension_ins_exclusion', // 年金保険適用除外理由
        pension_office_symbol: 'pension_ins_jigyousyo_symbol', // ccus年金保険事業所整理記号
        pension_office_number: 'pension_ins_jigyousyo_number', // ccus年金保険事業所番号
        employment_insurance_flag: 'employment_ins_status', // ccus雇用保険加入状況
        employment_insurance_reason_exclusion: 'employment_ins_exclusion', // ccus雇用保険適用除外理由
        employment_insurance_insurance_number: 'employment_ins_number', // ccus雇用保険労働保険番号
      },
    };
    this.events = {
      dialog: {
        // ダイアログ
        goBack: this.handleGoBackDialog, // 閉じる
      },
      form: {
        // フォーム関連
        setFormValue: this.setFormValue, // textareaの値セット
        setFormValueTel: this.setFormValueTel, // 電話番号項目専用の
        validate: this.validate, // 入力チェック
        setCalendar: this.setCalendar, // カレンダーの日付セット
        allInputInformation: this.allInputInformation, // ccus入力情報を全て転記
        submit: this.submit, // 会社登録
        uploadFile: this.uploadFile, // ファイル追加予定
        deleteFile: this.deleteFile, // ファイル削除予定
        addOtherIndustryPermission: this.addOtherIndustryPermission,
        editOtherIndustryPermission: this.editOtherIndustryPermission,
        deleteOtherIndustryLicense: this.deleteOtherIndustryLicense,
        deleteOldCompanyPermissionDocuments: this
          .deleteOldCompanyPermissionDocuments,
        handleDeletePermissionExistGreenFile: this
          .handleDeletePermissionExistGreenFile,
      },
    };
    // 戻るダイアログ
    this.GoBack = {
      callback: {
        clear: () => {
          _masterSlideLoader.show('PartnerCompanyBranchSafetyPreview', {
            state: {
              id: this.selectedCompanyId,
              selectedPartnerCompanyBranchId: this
                .selectedPartnerCompanyBranchId,
            },
          });
          dialogLoader.close();
        },
        close: () => {
          dialogLoader.close();
        },
      },
    };
    this.initCompanyDocuments = [];
    this.updatingFlag = false;
    this.eventCompanyBranchPermissionCommon = {
      handleCompanyBranchPermission: this.handleCompanyBranchPermission,
      handleDeleteCompanyBranchPermission: this
        .handleDeleteCompanyBranchPermission,
      download: this.download,
    };
    this.confirmDeleteDialogFn = null;
    this.isSubmittingFlag = false;
  }

  getExpiration = async () => {
    await CompanyService.expirations(this.selectedCompanyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  async componentDidMount() {
    this.setCompanyName();
    await this.getGreenData(this.selectedPartnerCompanyBranchId);

    const params = { offset: 0, is_limit: 0 };

    AttachDocuments.documentCodes(params).then(({ result, data }) => {
      if (result) {
        const { document_codes: documentCodes } = data.entities;
        const file_typeL = _.map(
          _.uniqBy(documentCodes, type => type.file_typeL),
          type => type.file_typeL
        );
        const { formValues } = this.state;

        this.setState({
          documentCodes,
          formValues: {
            ...formValues,
            company_documents: {
              ...formValues.company_documents,
              file_typeL,
            },
          },
        });
      }
    });

    CompanyService.getPartnerCompanyBranchDocuments(
      this.selectedCompanyId,
      this.selectedPartnerCompanyBranchId,
      params
    ).then(({ result, data }) => {
      if (result) {
        const { company_documents: companyDocuments } = data.entities;
        this.setState({ companyDocuments });
        this.initCompanyDocuments = companyDocuments;
      }
    });

    PartnerCompanyBranchService.show(
      this.selectedCompanyId,
      this.selectedPartnerCompanyBranchId
    ).then(({ result, data }) => {
      if (result) {
        const partnerCompanyBranch = _.get(
          data,
          'entities.partner_company_branch'
        );
        this.setState({ partnerCompanyBranch });
      }
    });
    this.getExpiration();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevState.companyDocuments, this.state.companyDocuments)) {
      const files = _.map(this.state.companyDocuments, file => {
        const newFile = {
          file_typeL: file.file_typeL,
          file_typeS: file.file_typeS,
          file_name: file.file_name,
        };

        if (file.id) {
          newFile['id'] = file.id;
        } else {
          newFile['temp_file_key'] = file.temp_file_key;
        }

        return newFile;
      });

      this.setState({
        formValues: {
          ...this.state.formValues,
          company_documents: {
            ...this.state.formValues.company_documents,
            files,
          },
        },
      });
    }
  }

  componentWillUnmount() {
    SessionStorageService.removeSelectedPartnerCompanyBranchSafetyId();
  }

  uploadFile = async (file, typeL, typeS) => {
    attachDocumentCompanyUploadState(
      this.state.companyDocuments,
      documents => {
        this.setState(
          { companyDocuments: documents },
          this.validateAllAttachFiles
        );
      },
      this.selectedCompanyId,
      file,
      typeL,
      typeS
    );
  };

  deleteFile = file => {
    attachDocumentDeleteState(
      this.state.companyDocuments,
      documents => {
        this.setState(
          { companyDocuments: documents },
          this.validateAllAttachFiles
        );
      },
      file
    );
  };

  validateAllAttachFiles = () => {
    let invalid = !this.filesCheck();
    if (!_.isEmpty(this.state.errorMessages)) {
      invalid = true;
    }
    this.setState({
      validate: {
        invalid,
      },
    });
  };

  // 添付ファイルのサイズ・タイプ・ファイル名が存在するかをチェック
  filesCheck = () => {
    const { companyDocuments: files } = this.state;
    return !(_.some(files, 'invalidSize') || _.some(files, 'invalidType') || _.some(files, 'invalidName'));
  };

  filterErrorMessage = errorMessages => {
    _.each(this.state.clearValuesArr, values => {
      if (values.targetValue !== '1') {
        switch (values.targetName) {
          case 'construction_industry_permission_flag':
            errorMessages = _.omit(errorMessages, [
              'company_branch_permissions',
            ]);
            break;
          case 'partner_company_branch':
            errorMessages = _.omit(errorMessages, ['partner_company_branch']);
            break;
          case 'health_insurance_flag':
            if (
              values.targetValue === '2' &&
              _.has(
                this.state.formValues,
                'company_branch_insurance.health_insurance_reason_exclusion'
              )
            ) {
              if (
                this.state.formValues.company_branch_insurance
                  .health_insurance_reason_exclusion === '５人未満個人事業所' &&
                this.state.formValues.company_branch_insurance
                  .health_insurance_type === '国民健康保険'
              ) {
                errorMessages.company_branch_insurance &&
                  delete errorMessages.company_branch_insurance[
                    this.companyBranchInsuranceKeys[values.targetName]
                  ];
              } else {
                errorMessages = _.omit(
                  errorMessages,
                  ['company_branch_insurance']['health_insurance_office_number']
                );
              }
              break;
            }
            if (values.targetValue === '0') {
              errorMessages.company_branch_insurance &&
                delete errorMessages.company_branch_insurance[
                  this.companyBranchInsuranceKeys[values.targetName]
                ];
            }
            break;
          case 'health_insurance_type':
            if (
              this.state.formValues.company_branch_insurance
                .health_insurance_flag ===
                EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
              this.state.formValues.company_branch_insurance
                .health_insurance_reason_exclusion === '５人未満個人事業所' &&
              values.targetValue === '国民健康保険'
            ) {
              errorMessages.company_branch_insurance &&
                delete errorMessages.company_branch_insurance[
                  this.companyBranchInsuranceKeys.health_insurance_flag
                ];
            }
            break;
          default:
            errorMessages.company_branch_insurance &&
              delete errorMessages.company_branch_insurance[
                this.companyBranchInsuranceKeys[values.targetName]
              ];
            break;
        }
      }
    });
    if (_.isEmpty(errorMessages.company_branch_insurance)) {
      errorMessages = _.omit(errorMessages, ['company_branch_insurance']);
    }
    return errorMessages;
  };

  /** フォームチェック
   * パラメーターが入ってる場合はフォーカス外した入力表のみチェックするため、全項目にはエラーメッセージ表示されない
   * @param targetName {string} ブロック名
   * @param e {events} イベント
   * @return bool
   */
  validate = (keyName, targetName = '', index = null) => {
    const { formValues } = this.state;
    let { errorMessages } = _.cloneDeep(this.state);
    if (!_.has(formValues, keyName) && !_.has(formValues, keyName)) {
      throw new Error('CompanySaftyEdit.jsx validate');
    }
    if (_.has(this.state.formValues, keyName)) {
      errorMessages = this.validateSafetyValues(keyName, targetName, index);
    } else {
      throw new Error(`PrimeCompanyEdit.jsx validateskeyName`);
    }

    errorMessages = this.filterErrorMessage(errorMessages);
    //更新ボタン状態
    let invalid;
    if (!this.filesCheck()) {
      invalid = true;
    } else {
      invalid = false;
    }
    if (!this.handleValidateCompanyBranchPermission()) {
      invalid = true;
    }
    invalid = invalid || !this.validateOtherIndustryPermission().status;

    this.setState(
      {
        errorMessages,
        validate: { invalid },
        triggerValidate: !this.state.triggerValidate,
      },
      () => {
        this.checkRequired();
      }
    );
  };
  /**
   * 労務安全項目のバリデーションを実施している
   * @param {string} keyName: 労務安全項目のブロック単位のキー名
   * @param {string} targetName: バリデーションでの検証対象となる項目名
   * @param {number} index: バリデーション対象が配列でデータを持っていた場合の対象となる項目のindex
   */
  validateSafetyValues = (keyName, targetName, index) => {
    let errorMessages = _.cloneDeep(this.state.errorMessages);
    if (!errorMessages) {
      errorMessages = {};
    }

    const schema = companySaftyEditSchema();

    // スキーマを元にバリデーションしてる
    const result = validationByJoi_New(schema, {
      [keyName]: this.state.formValues[keyName],
    });

    // バリデーション失敗時
    if (!result.status) {
      /**
       * company_branch_permissionsは各indexではなく全てのindex(複数の灰色部分全体)で
       * バリデーションされる。
       * そのため、対象にエラーがなくても他indexにエラーがあるとバリデーション失敗時のルートになる
       */
      if (keyName === 'company_branch_permissions') {
        const companyBranchPermissionResult = result.messages[keyName];
        if (targetName === 'construction_industry_permission_flag') {
          errorMessages[
            'company_branch_permissions'
          ] = getCompanyBranchPermissionsErrorMsg(
            errorMessages['company_branch_permissions'],
            targetName,
            index,
            companyBranchPermissionResult
          );
        } else {
          if (companyBranchPermissionResult[index]) {
            errorMessages[
              'company_branch_permissions'
            ] = getCompanyBranchPermissionsErrorMsg(
              errorMessages['company_branch_permissions'],
              targetName,
              index,
              companyBranchPermissionResult
            );
          } else {
            if (_.has(errorMessages, `company_branch_permissions[${index}]`)) {
              // company_branch_permissionsが[undifined]という状況の対策。[undefined, {}]は正常
              if (errorMessages['company_branch_permissions'].length === 1) {
                errorMessages['company_branch_permissions'] = errorMessages[
                  'company_branch_permissions'
                ].filter((item, itemIndex) => itemIndex !== index);
              } else {
                errorMessages[
                  'company_branch_permissions'
                ] = getCompanyBranchPermissionsErrorMsg(
                  errorMessages['company_branch_permissions'],
                  targetName,
                  index,
                  companyBranchPermissionResult
                );
              }
            }
          }
          if (
            _.has(errorMessages, `company_branch_permissions`) &&
            errorMessages['company_branch_permissions'].length === 0
          ) {
            delete errorMessages['company_branch_permissions'];
          }
        }
      }
      // 保険情報とか他の労務安全
      else {
        // 失敗
        errorMessages[keyName] = result.messages[keyName];
      }
    } else {
      // 成功時にエラーメッセージを消す
      if (_.has(errorMessages, `${keyName}`)) {
        delete errorMessages[keyName];
      }
    }
    return errorMessages;
  };

  validateAll = () => {
    const state = _.cloneDeep(this.state);
    let errorMessages = state.errorMessages;

    const safetyResult = validationByJoi_New(
      this.saftyEditSchema,
      state.formValues
    );

    _.each(safetyResult.messages, (type, key) => {
      errorMessages =
        key === 'company_branch_permissions'
          ? {
              ...errorMessages,
              company_branch_permissions:
                safetyResult.messages.company_branch_permissions,
            }
          : {
              ...errorMessages,
              [key]: { ...type },
            };
    });
    errorMessages = this.filterErrorMessage(errorMessages);
    //更新ボタン状態
    let invalid;
    if (!this.filesCheck()) {
      invalid = true;
    } else {
      invalid = false;
    }

    invalid = invalid || !this.validateOtherIndustryPermission().status;

    if (Object.keys(errorMessages).length > 0) {
      invalid = true;
    }
    if (!this.handleValidateCompanyBranchPermission()) {
      invalid = true;
    }
    this.setState(
      {
        errorMessages,
        validate: {
          invalid,
        },
        triggerValidate: !this.state.triggerValidate,
      },
      () => {
        this.checkRequired();
      }
    );
    return invalid;
  };

  validateOtherIndustryPermission = () => {
    const fields = ['other_company_branch_permission_groups', 'company_detail'];
    return validationByJoi(
      schemaOtherIndustryLicense,
      _.pick(this.state.formValues, fields)
    );
  };

  setCompanyName = () => {
    this.setState(
      {
        isLoading: true,
      },
      async () => {
        const companyName = await getPartnerCompanyName(this.selectedCompanyId);
        this.setState({ selectedCompanyName: companyName, isLoading: false });
      }
    );
  };

  // 健康保険データ内で加入状況などが未設定の場合初期値設定する
  setDefaultFormValues = (key, value, formValues) => {
    const newFormValues = _.cloneDeep(formValues);
    switch (key) {
      case 'health_insurance_flag': // 健康保険 加入状況
      case 'pension_flag': // 年金保険 加入状況
      case 'employment_insurance_flag': // 雇用保険 加入状況
        if (isNullOrUndefinedOrEmptyStr(value)) {
          newFormValues['company_branch_insurance'][key] =
            EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID; // 「無」に設定
        }
        break;
      default:
        break;
    }
    return newFormValues;
  };

  setOtherValueForFormValues = (key, value, data, formValues) => {
    const newFormValues = _.cloneDeep(formValues);
    if (
      key === 'health_insurance_type' &&
      data.company_branch_insurance.health_insurance_flag === '1'
    ) {
      const targetHealthInsuranceTypesComboBoxList = filterComboBoxHealthInsuranceTypeWhenExist(
        this.state.comboboxList.health_insurance_types
      );
      const target = targetHealthInsuranceTypesComboBoxList.find(
        item => item.name === value
      );
      if (!target && value) {
        newFormValues['company_branch_insurance']['health_insurance_type'] =
          'その他';
        newFormValues['company_branch_insurance'][
          'health_insurance_type_other'
        ] = value;
      }
    }
    if (
      key === 'health_insurance_reason_exclusion'
      // &&
      // data.company_branch_insurance.health_insurance_flag === '2'
    ) {
      const target = this.state.comboboxList.health_insurance_exclusions.find(
        item => item.tekiyoujogai_reason === value
      );
      if (!target && value) {
        newFormValues['company_branch_insurance'][
          'health_insurance_reason_exclusion'
        ] = 'その他';
        newFormValues['company_branch_insurance'][
          'health_insurance_reason_exclusion_other'
        ] = value;
      }
    }
    if (
      key === 'pension_type' &&
      data.company_branch_insurance.pension_flag === '1'
    ) {
      const targetPensionComboBoxList = filterComboBoxPensionInsuranceTypeWhenExist(
        this.state.comboboxList.pension_insurance_types
      );
      const target = targetPensionComboBoxList.find(
        item => item.name === value
      );
      if (!target && value) {
        newFormValues['company_branch_insurance']['pension_type'] = 'その他';
        newFormValues['company_branch_insurance']['pension_type_other'] = value;
      }
    }
    if (
      key === 'pension_reason_exclusion'
      // && data.company_branch_insurance.pension_flag === '2'
    ) {
      const target = this.state.comboboxList.pension_insurance_exclusions.find(
        item => item.tekiyoujogai_reason === value
      );
      if (!target && value) {
        newFormValues['company_branch_insurance']['pension_reason_exclusion'] =
          'その他';
        newFormValues['company_branch_insurance'][
          'pension_reason_exclusion_other'
        ] = value;
      }
    }
    if (
      key === 'employment_insurance_reason_exclusion'
      // && data.company_branch_insurance.employment_insurance_flag === '2'
    ) {
      const target = this.state.comboboxList.employment_insurance_exclusions.find(
        item => item.tekiyoujogai_reason === value
      );
      if (!target && value) {
        newFormValues['company_branch_insurance'][
          'employment_insurance_reason_exclusion'
        ] = 'その他';
        newFormValues['company_branch_insurance'][
          'employment_insurance_reason_exclusion_other'
        ] = value;
      }
    }

    return newFormValues;
  };

  cleanupFormValuesBeforeUpdate = formValues => {
    let newFormValues = _.cloneDeep(formValues);
    let companyBranchInsurance = newFormValues['company_branch_insurance'];

    companyBranchInsurance = cleanupBeforeUpdateUtil.cleanupHealthInsuranceValues(
      companyBranchInsurance
    );
    companyBranchInsurance = cleanupBeforeUpdateUtil.cleanupPensionValues(
      companyBranchInsurance
    );

    companyBranchInsurance = cleanupBeforeUpdateUtil.cleanupEmploymentInsuranceValues(
      companyBranchInsurance
    );

    newFormValues['company_branch_insurance'] = companyBranchInsurance;
    newFormValues = _.omit(newFormValues, [
      'company_branch_permissions',
      'other_company_branch_permission_groups',
      'delete_company_branch_permission_ids',
      'old_company_permission_documents',
    ]);
    newFormValues.company_detail = _.omit(newFormValues.company_detail, [
      'other_industry_permission_flag',
    ]);
    return newFormValues;
  };

  /**
   * 労務安全情報取得
   */
  getGreenData = branchId => {
    const ignoredKeys = [
      'worker_compensation_flag',
      'worker_compensation_number',
      'worker_compensation_organize_number',
      'worker_add_on_compensation_flag',
      'const_subscription_flag',
      'const_subscription_number',
      'enterprise_subscription_flag',
      'enterprise_subscription_number',
      'other_subscription_flag',
      'other_subscription_name',
      'acceptance_foreign_workers_flag',
      'certification_number',
      'supervisor_worker_id',
      'supervisor_name',
      'supervisor_position_name',
      'supervisor_tel',
      'leader_worker_id',
      'leader_name',
      'leader_position_name',
      'work_place',
      'engagement_content',
      'engagement_start_date',
      'engagement_end_date',
    ];
    // フォームに値セット

    // ccus事業者情報取得
    const param = { company_id: this.selectedCompanyId };

    GreenService.jigyousya_list(param).then(response => {
      if (!response.result) {
        return;
      }
      const data = response.data.entities;
      if (_.isNull(data)) {
        return;
      }

      let ccusformValues = _.cloneDeep(this.state.ccusformValues);
      // daihyousya_name,daihyousya_kana_nameに結合した名前を挿入
      ccusformValues.ccus_jigyousyas.daihyousya_name =
        data.daihyousya_last_name + data.daihyousya_first_name;
      ccusformValues.ccus_jigyousyas.daihyousya_kana_name =
        data.daihyousya_kana_last_name + data.daihyousya_kana_first_name;
      // initFormにて取得したデータを格納
      ccusformValues.ccus_jigyousyas = this.initForm(
        data,
        ccusformValues.ccus_jigyousyas
      );

      this.setState({ ccusformValues });
    });

    // 振興局情報APIから取得
    RegionalDevelopmentBureauxService.list().then(response => {
      if (!response.result) {
        return;
      }
      const bureaux = response.data.entities.regional_development_bureaux;
      this.setState({ bureaux });
    });

    // checkbox,combobox内に表示する情報取得
    GreenService.ccus_list().then(response => {
      if (!response.result) {
        return;
      }
      let checkboxList = _.cloneDeep(this.state.checkboxList);
      let comboboxList = _.cloneDeep(this.state.comboboxList);
      const data = response.data.entities;
      // initFormにて取得したデータを格納
      checkboxList = this.initForm(data, checkboxList);
      comboboxList = this.initForm(data, comboboxList);
      this.setState(
        {
          checkboxList,
          comboboxList,
        },
        () => {
          GreenService.getPartnerCompanyBranchGreenFiles(
            this.selectedCompanyId,
            branchId
          ).then(response => {
            if (!response.result) {
              return;
            }
            let formValues = _.cloneDeep(this.state.formValues);
            const data = response.data.entities;
            _.map(data, (company_data, company_key) => {
              if (
                !_.includes(EXCLUDE_KEY_COMPANY_BRANCH_PERMISSIONS, company_key)
              ) {
                _.map(company_data, (data, key) => {
                  if (!ignoredKeys.includes(key)) {
                    formValues[company_key][key] = data;
                  }
                });
              }
            });
            formValues.old_company_permission_documents = _.get(
              data,
              'old_company_permission_documents'
            );
            formValues.company_branch_permissions = _.get(
              data,
              'common_company_branch_permission_groups'
            );

            formValues.other_company_branch_permission_groups =
              data.other_company_branch_permission_groups;
            formValues.company_detail.other_industry_permission_flag =
              _.get(data, 'company_detail.other_permission_flag') ||
              EXISTANCE_FLAG.NOEXIST.VALUE;

            // // 健康保険情報 加入状況が未設定の場合初期値設定する
            // (現在対象外のためコメントアウトで残す)
            // _.map(data.company_branch_insurance, (value, key) => {
            //   formValues = this.setDefaultFormValues(key, value, formValues);
            // });

            // 保険情報が初期取得の時点で状況が「無」「適用除外」の場合、項目の値を消す
            // TODO: 可能ならfindStatusおよびclearStateByConditionで処理する
            // 建退共、中退共、その他退職金共済制度の加入フラグはデフォルトで「無」のため「有」以外（nullや空文字含む）の場合には'0'を設定する
            _.map(data.company_branch_insurance, (value, key) => {
              formValues = this.setOtherValueForFormValues(
                key,
                value,
                data,
                formValues
              );
              // ユーザーデータを残すため、読み込み時点では上書きしない
              // if (
              //   key === 'health_insurance_flag' &&
              //   value === EXISTANCE_EXCLUSION_FLAG.ID
              // ) {
              //   formValues['company_branch_insurance'][
              //     'health_insurance_type'
              //   ] = '国民年金';
              //   formValues['company_branch_insurance'][
              //     'health_insurance_reason_exclusion'
              //   ] = 'けんぽ適用除外承認済';
              // }
            });

            if (data.company_branch_insurance !== null) {
              // if (
              //   data.company_branch_insurance['health_insurance_flag'] ===
              //     EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
              //   data.company_branch_insurance[
              //     'health_insurance_reason_exclusion'
              //   ] === 'けんぽ適用除外承認済'
              // ) {
              //   formValues['company_branch_insurance'][
              //     'health_insurance_type'
              //   ] = '国民健康保険組合';
              // }
              formValues[
                'company_branch_insurance'
              ] = this.setOtherStateByHealthInsurance(
                formValues['company_branch_insurance']
              );
              formValues[
                'company_branch_insurance'
              ] = this.setOtherStateByPensionInsurance(
                formValues['company_branch_insurance']
              );

              // 年金加入状況が有で何も保険種類が何も設定されていない場合には必ず厚生年金を設定する
              if (
                data.company_branch_insurance['pension_flag'] ===
                  EXISTANCE_EXCLUSION_FLAG.EXIST.ID &&
                isNullOrUndefinedOrEmptyStr(
                  data.company_branch_insurance['pension_type']
                )
              ) {
                formValues['company_branch_insurance']['pension_type'] =
                  '厚生年金';
              }

              if (
                data.company_branch_insurance['pension_flag'] ===
                EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
              ) {
                // 年金加入状況が適用除外
                // 何も保険種類が何も設定されていない場合には必ず「国民年金」を設定する
                if (
                  isNullOrUndefinedOrEmptyStr(
                    data.company_branch_insurance['pension_type']
                  )
                ) {
                  formValues['company_branch_insurance']['pension_type'] =
                    '国民年金';
                }
              }
              if (
                data.company_branch_insurance['pension_flag'] ===
                EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
              ) {
                // 何も適用除外理由が設定されていない場合には必ず「５人未満個人事業所」
                if (
                  isNullOrUndefinedOrEmptyStr(
                    data.company_branch_insurance['pension_reason_exclusion']
                  )
                ) {
                  formValues['company_branch_insurance'][
                    'pension_reason_exclusion'
                  ] = '５人未満個人事業所';
                }
              }
            }

            this.setState({ formValues }, async () => {
              await this.handleRequireColumnCompanyBranchPermission();
              await this.resetRequiredColumnOtherIndustryPermissionChange();
              await this.validate('company_detail');
              await this.validate('other_company_branch_permission_groups');
              this.checkExistAndSet();
            });
          });
        }
      );
    });
  };

  checkExistAndSet = () => {
    // 既存データで不整合な組み合わせがないかをフロントでチェックする
    const companyBranchInsurance = _.cloneDeep(
      this.state.formValues.company_branch_insurance
    );

    const noticeData = checkExistData(companyBranchInsurance);
    let userFixApproval = false;
    if (
      noticeData['healthInsurance'].length === 0 &&
      noticeData['pensionInsurance'].length === 0 &&
      noticeData['employmentInsurance'].length === 0
    ) {
      userFixApproval = true; // 想定外の組み合わせデータがないため通常の更新フローにする
    }

    const requestUserFixListByHealthInsurance = noticeData['healthInsurance'];
    const requestUserFixListByPensionInsurance = noticeData['pensionInsurance'];
    const requestUserFixListByEmploymentInsurance =
      noticeData['employmentInsurance'];

    this.setState(
      {
        userFixApproval,
        requestUserFixListByHealthInsurance,
        requestUserFixListByPensionInsurance,
        requestUserFixListByEmploymentInsurance,
        initialLoadingSocialInsuranceFlag: {
          ...this.state.initialLoadingSocialInsuranceFlag,
          healthInsuranceFlag: this.state.formValues.company_branch_insurance
            .health_insurance_flag,
          pensionFlag: this.state.formValues.company_branch_insurance
            .pension_flag,
          employmentInsuranceFlag: this.state.formValues
            .company_branch_insurance.employment_insurance_flag,
        },
      },
      () => {
        if (
          hasRequestUserFixList({
            requestUserFixListByHealthInsurance,
            requestUserFixListByPensionInsurance,
            requestUserFixListByEmploymentInsurance,
          })
        ) {
          showFixedDataAnnouncementDialog(
            requestUserFixListByHealthInsurance,
            requestUserFixListByPensionInsurance,
            requestUserFixListByEmploymentInsurance
          );
        }
      }
    );
  };
  /**
   * フォーム生成
   * @param data {object} 会社情報
   */
  initForm(data, formData) {
    _.map(data, (value, key) => {
      if (_.has(formData, key) && !_.isNull(value)) {
        if (key === 'start_date' && this.matchFormatDateHyphen(value)) {
          formData[key] = _.replace(value, /-/g, '/');
        } else {
          formData[key] = _.defaultTo(value, '');
        }
      }
    });
    return formData;
  }

  /**
   * 対象データがハイフン区切りかチェック
   * @param valie {String} 日付データ
   */
  matchFormatDateHyphen = value => {
    return value.match(/^\d{1,4}-\d{1,2}-\d{1,2}$/) ? true : false;
  };

  getClearList = (targetName, targetValue, list) => {
    list = _.filter(list, obj => {
      return obj.targetName !== targetName;
    });
    list.push({ targetName, targetValue });
    return list;
  };

  /**
   * 入力
   * @param name {string} テーブル名
   * @param e {events} イベント
   */
  setFormValue = (name, e, index) => {
    const formValues = _.cloneDeep(this.state.formValues);
    const targetName = e.target.name;
    let targetValue = deleteControlCode(e.target.value);
    _.map(this.targetNumberType, targetNumberName => {
      if (targetNumberName === targetName) {
        targetValue = Number(e.target.value);
      }
    });

    if (index >= 0) {
      formValues[name][index][e.target.name] = targetValue;
    } else {
      formValues[name][e.target.name] = targetValue;
    }

    // 許可業種コード挿入処理
    if (targetName === 'authorized_industry_names') {
      const construct_permit_industry_types = this.state.comboboxList
        .construct_permit_industry_types;
      _.map(construct_permit_industry_types, array => {
        if (array['construct_permit_industry_type_name'] === targetValue) {
          formValues[name][index]['authorized_industry_codes'] =
            array['construct_permit_industry_type_code'];
        }
      });
    }

    this.setState({ formValues }, () => {
      // formValuesへのsetStateを別関数で行っているものと、この関数で行っているものに分ける
      if (
        [
          'permitted_source_section',
          'construction_industry_permission_flag',
          'health_insurance_flag',
          'other_industry_permission_flag',
        ].includes(targetName)
      ) {
        switch (targetName) {
          case 'construction_industry_permission_flag':
            this.handleRequireColumnCompanyBranchPermission();
            break;
          case 'health_insurance_flag':
            this.resetClearColumnWhenHealthInsuranceStatus();
            break;
          case 'other_industry_permission_flag':
            this.resetRequiredColumnOtherIndustryPermissionChange();
            break;
          default:
            break;
        }
      } else {
        switch (targetName) {
          case 'pension_flag':
            formValues[
              'company_branch_insurance'
            ] = this.setOtherStateByPensionInsurance(
              formValues.company_branch_insurance
            );
            const {
              pension_type,
              pension_reason_exclusion,
            } = formValues.company_branch_insurance;

            if (
              targetValue === EXISTANCE_EXCLUSION_FLAG.EXIST.ID &&
              isNullOrUndefinedOrEmptyStr(pension_type)
            ) {
              formValues.company_branch_insurance.pension_type = '厚生年金';
            }
            if (targetValue === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID) {
              if (isNullOrUndefinedOrEmptyStr(pension_type)) {
                formValues.company_branch_insurance.pension_type = '国民年金';
              }
              if (isNullOrUndefinedOrEmptyStr(pension_reason_exclusion)) {
                formValues.company_branch_insurance.pension_reason_exclusion =
                  '５人未満個人事業所';
              }
            }
            break;
          case 'health_insurance_reason_exclusion':
            if (targetValue === '') {
              formValues.company_branch_insurance.health_insurance_type = '';
            }
            if (targetValue === 'けんぽ適用除外承認済') {
              formValues.company_branch_insurance.health_insurance_type =
                '国民健康保険組合';
            }
            break;
          case 'health_insurance_type_other':
          case 'health_insurance_reason_exclusion_other':
            formValues.company_branch_insurance = this.setOtherStateByHealthInsurance(
              formValues.company_branch_insurance
            );
            break;
          case 'pension_type_other':
            formValues.company_branch_insurance = this.setOtherStateByPensionInsurance(
              formValues.company_branch_insurance
            );
            break;
          case 'pension_reason_exclusion_other':
            formValues.company_branch_insurance = this.setOtherStateByPensionInsurance(
              formValues.company_branch_insurance
            );
            break;
          case 'employment_insurance_reason_exclusion_other':
            formValues.company_branch_insurance = this.setOtherStateByEmploymentInsurance(
              formValues.company_branch_insurance
            );
            break;
          default:
            break;
        }
        this.setState({
          formValues: {
            ...this.state.formValues,
            company_branch_insurance: {
              ...this.state.formValues.company_branch_insurance,
              ...formValues.company_branch_insurance,
            },
          },
        });
      }

      if (this.clearFlagList.includes(targetName)) {
        const clearArrs = this.getClearList(
          targetName,
          targetValue,
          this.state.clearValuesArr
        );

        this.setState({ clearValuesArr: clearArrs }, () => {
          switch (targetName) {
            case 'construction_industry_permission_flag':
              this.validate('company_branch_permissions', targetName, index);
              break;
            default:
              this.validate('company_branch_insurance');
          }
        });
      } else {
        this.validate(name, targetName, index);
      }
    });
  };

  /**
   * 電話番号項目入力
   * （３個の入力項目を結合した入力値が必要のためイベントからではなく直接値を渡すようにする）
   * @param tableName {string} テーブル名
   * @param targetName {string}
   * @param value {string}
   */
  setFormValueTel = (tableName, targetName, value) => {
    const formValues = _.cloneDeep(this.state.formValues);
    formValues[tableName][targetName] = deleteControlCode(value);
    this.setState({ formValues });
  };

  /**
   * calendarの値をセット
   * @param name {string} テーブル名
   * @param column {string} カラム名
   * @param date {date} 日付
   */
  setCalendar = (name, column, date, index) => {
    const formValues = _.cloneDeep(this.state.formValues);

    if (index >= 0) {
      formValues[name][index][column] = date;
    } else {
      formValues[name][column] = date;
    }

    this.setState({ formValues });
  };

  /**
   * ccus入力情報を全て転記
   * @param inputKey {string} 転記対象のテーブル名
   *  company_detail:              代表者情報
   *  company_branch_permissions:  許可情報
   *  company_branch_insurance:    保険情報
   */
  allInputInformation = (inputKey, targetFields) => {
    if (
      ![
        'company_detail',
        'company_branch_permissions',
        'company_branch_insurance',
      ].includes(inputKey)
    ) {
      throw new Error('CompanySaftyEdit.jsx allInputInformation');
    }

    const formValues = _.cloneDeep(this.state.formValues);
    const ccus_jigyousyas = _.cloneDeep(
      this.state.ccusformValues.ccus_jigyousyas
    );

    if (inputKey === 'company_branch_permissions') {
      const formValuesPermissionFlag =
        formValues.company_detail.construction_industry_permission_flag;
      const ccusPermitFlag = ccus_jigyousyas.construct_permit_availability;
      formValues.company_detail.construction_industry_permission_flag = isNullOrEmpty(
        ccusPermitFlag
      )
        ? formValuesPermissionFlag
        : ccusPermitFlag; // 建設業許可有無フラグ
      _.each(formValues[inputKey], item => {
        _.each(this.formToCcusNameMap[inputKey], (ccusName, formName) => {
          item[formName] = isNullOrEmpty(ccus_jigyousyas[ccusName])
            ? item[formName]
            : ccus_jigyousyas[ccusName];
        });
      });
    } else {
      _.each(
        targetFields || this.formToCcusNameMap[inputKey],
        (ccusName, formName) => {
          formValues[inputKey][formName] = isNullOrEmpty(
            ccus_jigyousyas[ccusName]
          )
            ? formValues[inputKey][formName]
            : ccus_jigyousyas[ccusName];
        }
      );
    }

    this.setState({ formValues }, () => {
      if (inputKey === 'company_branch_permissions') {
        const clearValuesArr = this.getClearList(
          'construction_industry_permission_flag',
          FlagIndicator[0].id,
          this.state.clearValuesArr
        );
        this.setState(
          { clearValuesArr, triggerValidate: !this.state.triggerValidate },
          () => {
            this.validate(inputKey);
          }
        );
        return;
      }

      if (inputKey === 'company_branch_insurance') {
        const keys = _.keys(this.companyBranchInsuranceKeys);
        const clearValuesArr = keys.map(key => {
          return this.getClearList(
            key,
            formValues.company_branch_insurance[key],
            this.state.clearValuesArr
          );
        });

        this.setState({ clearValuesArr }, () => {
          this.validate(inputKey);
        });
      } else {
        this.validate(inputKey);
      }
    });
  };

  addOtherIndustryPermission = data => {
    const { formValues } = this.state;
    data.id = _.uniqueId('other_company_branch_permission_groups_id');
    data.isCreate = true;
    const otherIndustryPermissions = _.clone(
      formValues.other_company_branch_permission_groups
    );
    otherIndustryPermissions.push(data);
    this.setState(
      {
        formValues: {
          ...formValues,
          other_company_branch_permission_groups: otherIndustryPermissions,
        },
      },
      () => this.validate('other_company_branch_permission_groups')
    );
  };

  editOtherIndustryPermission = (id, data) => {
    data.invalid_flag = false;
    const otherIndustryPermissions = _.clone(
      this.state.formValues.other_company_branch_permission_groups
    );
    const editIndex = _.findIndex(
      otherIndustryPermissions,
      license => license.id === id
    );
    if (editIndex < 0) {
      return;
    }
    otherIndustryPermissions[editIndex] = {
      ...otherIndustryPermissions[editIndex],
      ...data,
    };
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          other_company_branch_permission_groups: otherIndustryPermissions,
        },
      },
      () => this.validate('other_company_branch_permission_groups')
    );
  };

  deleteOtherIndustryLicense = id => {
    const {
      other_company_branch_permission_groups,
      delete_company_branch_permission_group_ids,
    } = this.state.formValues;
    const otherIndustryPermissions = _.clone(
      other_company_branch_permission_groups
    );
    const deleteIndex = _.findIndex(
      otherIndustryPermissions,
      license => license.id === id
    );
    if (deleteIndex < 0) {
      return;
    }

    const { isCreate, company_branch_permission_id } = otherIndustryPermissions[
      deleteIndex
    ];
    const deletedCompanyBranchPermissionIds = [];
    if (!isCreate) {
      delete_company_branch_permission_group_ids.push(id);
      deletedCompanyBranchPermissionIds.push(company_branch_permission_id);
    }
    otherIndustryPermissions.splice(deleteIndex, 1);
    this.handleDeletePermissionExistGreenFile(
      deletedCompanyBranchPermissionIds,
      () =>
        this.setState(
          {
            formValues: {
              ...this.state.formValues,
              other_company_branch_permission_groups: otherIndustryPermissions,
              delete_company_branch_permission_group_ids,
            },
          },
          () => this.validate('other_company_branch_permission_groups')
        )
    );
  };

  getStateWithConvertedDate = () => {
    const safetyValues = _.cloneDeep(this.state.formValues);

    _.each(safetyValues.company_branch_permissions, (item, index) => {
      safetyValues.company_branch_permissions[index].license_date = convertDate(
        item.license_date
      );

      safetyValues.company_branch_permissions[
        index
      ].license_update_date = convertDate(item.license_update_date);
    });

    _.each(safetyValues.other_company_branch_permission_groups, item => {
      item.license_update_date = convertDate(item.license_update_date);
      item.license_limit_date = convertDate(item.license_limit_date);
    });

    return safetyValues;
  };

  /**
   * 必須入力状況チェック
   */
  checkRequired = () => {
    const { formValues } = this.state;
    // 必須チェック
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    let count = 0;

    if (
      this.handleValidateCompanyBranchPermission() &&
      isConstructionIndustryPermissionStatus(
        formValues.company_detail.construction_industry_permission_flag
      )
    ) {
      count++;
    }
    if (
      String(
        _.get(requiredInput.columns, 'construction_industry_permission_flag')
      )
    ) {
      count++;
    }

    if (!_.isNil(formValues.company_detail.other_industry_permission_flag)) {
      count++;
    }
    if (
      isHasOtherIndustryPermission(
        formValues.company_detail.other_industry_permission_flag
      ) &&
      this.validateOtherIndustryPermission().status
    ) {
      count++;
    }

    requiredInput.count = count;
    requiredInput.total = _.size(requiredInput.columns);
    this.setState({ requiredInput });
  };

  getDeletePermissionExistGreenFile = async idsToDelete => {
    const response = await GreenService.getPartnerCompanyBranchPermissionIdsUsedGreenFile(
      this.selectedCompanyId,
      this.selectedPartnerCompanyBranchId,
      {
        company_branch_permission_ids: idsToDelete,
        is_prime_contractor: false,
      }
    );
    return {
      isSuccess: response.result,
      companyBranchPermissions: _.get(
        response,
        'data.entities.company_branch_permissions'
      ),
    };
  };

  handleDeletePermissionExistGreenFile = async (idsToDelete, callback) => {
    if (this.isSubmittingFlag) {
      return;
    }
    if (_.isEmpty(idsToDelete)) {
      return _.isFunction(callback) && callback();
    }
    this.isSubmittingFlag = true;
    const {
      isSuccess,
      companyBranchPermissions: companyBranchPermissionsExistGreenFile,
    } = await this.getDeletePermissionExistGreenFile(idsToDelete);
    this.isSubmittingFlag = false;
    if (!isSuccess) {
      this.showErrorDialog();
      return;
    }
    if (_.isEmpty(companyBranchPermissionsExistGreenFile)) {
      return _.isFunction(callback) && callback();
    }
    this.confirmDeleteDialogFn = () => {
      this.setState(
        {
          visibleConfirmDeleteDialog: false,
        },
        callback
      );
    };
    this.setState({
      visibleConfirmDeleteDialog: true,
      deleteCompanyBranchPermissionsExistGreenFile: companyBranchPermissionsExistGreenFile,
    });
  };

  /**
  /**
   * 協力会社管理者(等)
   * 「会社情報確認」画面
   * 「労務安全項目」
   * 更新
   */
  submit = onceAsyncRequest(async () => {
    if (this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;

    // データ取得時、組み合わせの注意文が出ている場合はデータを更新して良いか確認する
    if (!this.state.userFixApproval) {
      const {
        requestUserFixListByHealthInsurance,
        requestUserFixListByPensionInsurance,
        requestUserFixListByEmploymentInsurance,
        formValues,
      } = this.state;
      if (
        (requestUserFixListByHealthInsurance.length > 0 &&
          isNullOrUndefinedOrEmptyStr(
            formValues.company_branch_insurance.health_insurance_flag
          )) ||
        (requestUserFixListByPensionInsurance.length > 0 &&
          isNullOrUndefinedOrEmptyStr(
            formValues.company_branch_insurance.pension_flag
          )) ||
        (requestUserFixListByEmploymentInsurance.length > 0 &&
          isNullOrUndefinedOrEmptyStr(
            formValues.company_branch_insurance.employment_insurance_flag
          ))
      ) {
        showAskForFlagUpdateDialog({
          requestUserFixListByHealthInsurance,
          requestUserFixListByPensionInsurance,
          requestUserFixListByEmploymentInsurance,
          companyBranchInsurance: formValues.company_branch_insurance,
        });
        return;
      } else {
        showUserFixApprovalDialog({
          onConfirm: () => {
            this.setState(
              {
                userFixApproval: true,
              },
              () => {
                this.submit();
              }
            );
          },
        });
        return;
      }
    }
    if (
      hasRequestUserFixList({
        requestUserFixListByHealthInsurance: this.state
          .requestUserFixListByHealthInsurance,
        requestUserFixListByPensionInsurance: this.state
          .requestUserFixListByPensionInsurance,
        requestUserFixListByEmploymentInsurance: this.state
          .requestUserFixListByEmploymentInsurance,
      }) &&
      !this.state.userFixApproval
    ) {
      return;
    }
    let newFormValues = this.getStateWithConvertedDate();
    _.each(this.state.clearValuesArr, values => {
      newFormValues = this.clearStateByCondition(
        values.targetName,
        values.targetValue,
        newFormValues
      );
    });
    // result: validate.invalid、true = バリデーション失敗
    if (this.validateAll()) {
      return;
    }
    newFormValues.company_branch_permissions = this.setEmptyRegionalDevelopmentBureauIdToNull(
      newFormValues.company_branch_permissions
    );
    newFormValues.delete_company_branch_permission_group_ids = getAllCommonCompanyBranchPermissionId(
      newFormValues,
      newFormValues.delete_company_branch_permission_group_ids
    );
    newFormValues.company_branch_permission_groups = [
      ...(_.get(newFormValues, 'company_branch_permission_groups') || []),
      ...getParamCommonCompanyBranchPermission(newFormValues),
    ];
    newFormValues.delete_company_branch_permission_group_ids = concatOtherIndustryPermissionDeleteIds(
      newFormValues
    );
    newFormValues.company_branch_permission_groups = concatOtherIndustryPermissionGroupsSubmit(
      newFormValues
    );
    newFormValues.company_detail.other_permission_flag =
      newFormValues.company_detail.other_industry_permission_flag;
    const safetyValidateResult = this.safetyDocItemValidate();

    if (
      safetyValidateResult.status === false &&
      this.state.dialogStatus === DIALOG_STATUS.disabled.id
    ) {
      this.setSafetyDocErrorMessages(safetyValidateResult);
      this.onOpenSafetyDocItemErrorDialog();
      return;
    }

    this.setState({ dialogStatus: DIALOG_STATUS.disabled.id });

    newFormValues = this.cleanupFormValuesBeforeUpdate(newFormValues);
    await this.callApiSubmit(newFormValues);
  });

  callApiSubmit = async newFormValues => {
    // 下記のawaitは連打防止対応のため、削除禁止
    await GreenService.updatePartnerCompanyBranchGreenFile(
      this.selectedCompanyId,
      this.selectedPartnerCompanyBranchId,
      newFormValues
    ).then(response => {
      if (!response.result) {
        const params = {
          offset: 0,
          is_limit: 0,
        };

        CompanyService.getPartnerCompanyBranchDocuments(
          this.selectedCompanyId,
          this.selectedPartnerCompanyBranchId,
          params
        ).then(response => {
          if (
            response.result &&
            JSON.stringify(response.data.entities.company_documents) !==
              JSON.stringify(this.initCompanyDocuments)
          ) {
            dialogLoader.show(FormInformationDialog, {
              title: 'エラーが発生しました',
              message:
                '編集中に別のユーザーが更新を行っている可能性があります。\n最新の内容をご確認のうえ、必要であれば再度編集を行ってください。',
              buttonText: '編集画面を閉じる',
              onClose: () => {
                dialogLoader.close();
                this.updatingFlag = false;
                _masterSlideLoader.show('PartnerCompanyBranchSafetyPreview', {
                  state: {
                    id: this.selectedCompanyId,
                    selectedPartnerCompanyBranchId: this
                      .selectedPartnerCompanyBranchId,
                  },
                });
              },
            });
          } else {
            this.showUpdateErrorDialog();
          }
        });
      } else {
        dialogLoader.show(FormInformationDialog, {
          title: '支店の労務安全項目情報更新完了',
          message: '支店の労務安全項目情報の更新が完了しました。',
          onClose: () => {
            dialogLoader.close();
            this.updatingFlag = false;
            _masterSlideLoader.show('PartnerCompanyBranchSafetyPreview', {
              state: {
                id: this.selectedCompanyId,
                selectedPartnerCompanyBranchId: this
                  .selectedPartnerCompanyBranchId,
              },
            });
          },
        });
      }
    });
  };
  /**
   * 安全書類項目に未入力がないかの確認
   * 安全書類項目は必須ではない
   */
  safetyDocItemValidate = () => {
    const formValues = this.getStateWithConvertedDate();
    const { construction_industry_permission_flag } = formValues.company_detail;

    const {
      health_insurance_flag,
      pension_flag,
      employment_insurance_flag,
    } = formValues.company_branch_insurance;
    const param = {
      constructionIndustryPermissionFlag: construction_industry_permission_flag,
      healthInsuranceStatus: this.findStatus(
        HEALTH_INSURANCE_FLAG,
        health_insurance_flag
      ),
      pensionInsuranceStatus: this.findStatus(PENSION_FLAG, pension_flag),
      employmentInsuranceStatus: this.findStatus(
        EMPLOYMENT_INSURANCE_FLAG,
        employment_insurance_flag
      ),
      isPartnerCompanyBranchSafty: true,
    };
    const result = validationByJoi(schemaForSafetyDoc(param), formValues);

    const { company_detail } = _.cloneDeep(result.messages);
    if (company_detail) {
      delete company_detail['delegate_name'];
      delete company_detail['delegate_post'];
      result.messages['company_detail'] = company_detail;
    }

    return {
      status: result.status,
      messages: result.messages,
    };
  };

  showErrorDialog = () => {
    dialogLoader.show(FormInformationDialog, {
      title: 'エラーが発生しました',
      message:
        'エラーが発生しました。会社情報を開きなおし、再度操作を行ってください。',
      onClose: () => {
        dialogLoader.close();
        _masterSlideLoader.show('CompanyPreview', {
          state: {
            id: this.selectedCompanyId,
          },
        });
      },
    });
  };

  showUpdateErrorDialog = () => {
    dialogLoader.show(FormInformationDialog, {
      title: '更新に失敗しました',
      message: 'エラーが発生しました。再度操作を行ってください。',
      onClose: () => {
        dialogLoader.close();
        _masterSlideLoader.show('CompanyPreview', {
          state: {
            id: this.selectedCompanyId,
          },
        });
      },
    });
  };

  /**
   * 戻るダイアログ表示
   */
  handleGoBackDialog = () => {
    dialogLoader.show(CloseEditView, this.GoBack);
  };

  /**
   * stateのcheckboxListと対応するvaluesで一致するオブジェクトを返す
   * checkboxListはAPIからデータが返ってくるまで空
   */
  findStatus = (type, targetValue) => {
    const { checkboxList } = this.state;

    const fromInsuranceStatuses = targetValue => {
      if (!_.isEmpty(checkboxList.insurance_statuses)) {
        return this.state.checkboxList.insurance_statuses.find(
          item => item.value === targetValue
        );
      }
      return null;
    };

    switch (type) {
      case INSURANCE_STATUS:
      case HEALTH_INSURANCE_FLAG:
      case PENSION_FLAG:
      case EMPLOYMENT_INSURANCE_FLAG:
        return fromInsuranceStatuses(targetValue);
      default:
        return null;
    }
  };

  setSafetyDocErrorMessages = validateResult => {
    const errorMessages = createErrorMessageList(validateResult.messages);
    this.setState({
      confirmationModalSafetyDocItem: {
        errorPropertyList: errorMessages,
      },
    });
  };

  onCloseSafetyDocItemErrorDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.disabled.id,
    });
  };

  onOpenSafetyDocItemErrorDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id,
    });
  };

  /**
   * 各種保険加入状況によりstateの一部をリセットする
   */
  clearStateByCondition = (name, value, formValues) => {
    const selectedStatus = this.findStatus(name, value);
    let newFormValues = formValues;
    switch (name) {
      case CONSTRUCTION_INDUSTRY_PERMISSION_FLAG:
        newFormValues = this.clearConstructionIndustryPermissionState(
          formValues
        );
        break;
      case HEALTH_INSURANCE_FLAG:
        newFormValues = this.clearHealthInsuranceState(
          selectedStatus,
          formValues
        );
        break;
      case PENSION_FLAG:
        newFormValues = this.clearPensionInsuranceState(
          selectedStatus,
          formValues
        );
        break;
      case EMPLOYMENT_INSURANCE_FLAG:
        newFormValues = this.clearEmploymentInsuranceState(
          selectedStatus,
          formValues
        );
        break;
      default:
        break;
    }
    return newFormValues;
  };
  /**
   * 健康保険加入状況（有、無、適用除外）により不必要な入力値をクリアする
   */
  clearHealthInsuranceState = (selectedInsuranceStatus, formValues) => {
    switch (selectedInsuranceStatus.key) {
      case EXCLUSION:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            health_insurance_uninsured_reason: '',
          },
        };
        break;
      case PRESENCE:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            health_insurance_reason_exclusion: '',
            health_insurance_uninsured_reason: '',
          },
        };
        break;
      default:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            health_insurance_reason_exclusion: '',
          },
        };
        break;
    }
    return formValues;
  };

  /**
   * 年金保険加入状況（有、無、適用除外）により不必要な入力値をクリアする
   */
  clearPensionInsuranceState = (selectedInsuranceStatus, formValues) => {
    switch (selectedInsuranceStatus.key) {
      case EXCLUSION:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            pension_type_code: '',
            pension_office_symbol: '',
            pension_office_number: '',
            pension_uninsured_reason: '',
          },
        };
        break;
      case PRESENCE:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            pension_reason_exclusion: '',
            pension_uninsured_reason: '',
          },
        };
        break;
      default:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            pension_type_code: '',
            pension_type: '',
            pension_office_symbol: '',
            pension_office_number: '',
            pension_reason_exclusion: '',
          },
        };
        break;
    }
    return formValues;
  };

  /**
   * 雇用保険加入状況（有、無、適用除外）により不必要な入力値をクリアする
   */
  clearEmploymentInsuranceState = (selectedInsuranceStatus, formValues) => {
    switch (selectedInsuranceStatus.key) {
      case EXCLUSION:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            employment_insurance_insurance_number: '',
            employment_insurance_uninsured_reason: '',
          },
        };
        break;
      case PRESENCE:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            employment_insurance_reason_exclusion: '',
            employment_insurance_uninsured_reason: '',
          },
        };
        break;
      default:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            employment_insurance_insurance_number: '',
            employment_insurance_reason_exclusion: '',
          },
        };
        break;
    }
    return formValues;
  };

  clearConstructionIndustryPermissionState = formValues => {
    const constructionIndustryPermissionStatus = isConstructionIndustryPermissionStatus(
      formValues.company_detail.construction_industry_permission_flag
    );

    // 建設業許可が無し、未入力時にclear
    if (!constructionIndustryPermissionStatus) {
      const newConstructionIndustryPermissionState = formValues.company_branch_permissions.map(
        companyBranchPermission => {
          return {
            id: companyBranchPermission.id,
            permitted_source_section: null, // 許可元区分名
            prefectures_code_id: null, // 許可都道府県ID
            regional_development_bureau_id: null, // 振興局ID
            construction_industry_permission_section: null, // 建設許可区分名
            authorized_industry_codes: '', // 許可業種コード
            authorized_industry_names: '', // 許可業種名
            permission_number_l: '', // 許可番号 年度
            permission_number_r: '', // 許可番号 固有番号
            license_date: null, // 許可年月日
            license_update_date: null, // 許可更新年月日
          };
        }
      );
      formValues = {
        ...formValues,
        company_branch_permissions: newConstructionIndustryPermissionState,
      };
    }
    return formValues;
  };
  handleRequireColumnCompanyBranchPermission = () => {
    const { company_detail } = this.state.formValues;
    const isExistFlag = isConstructionIndustryPermissionStatus(
      company_detail.construction_industry_permission_flag
    );
    let columns = _.cloneDeep(this.state.requiredInput.columns);
    if (!isExistFlag) {
      _.remove(columns, item => item === 'company_branch_permissions');
    } else {
      columns = _.union(columns, ['company_branch_permissions']);
    }
    this.setState(
      {
        requiredInput: {
          ...this.state.requiredInput,
          columns,
        },
      },
      () => {
        this.checkRequired();
      }
    );
  };

  resetRequiredColumnOtherIndustryPermissionChange = () => {
    const { company_detail } = this.state.formValues;
    const otherIndustryPermissionFlag =
      company_detail['other_industry_permission_flag'];
    this.setState(
      {
        requiredInput: {
          ...this.state.requiredInput,
          columns: getRequiredColumnsOtherIndustryPermissionChange(
            otherIndustryPermissionFlag,
            this.state.requiredInput.columns
          ),
        },
      },
      this.checkRequired
    );
  };

  setOtherStateByHealthInsurance = companyBranchInsurance => {
    let newCompanyBranchInsurance = _.cloneDeep(companyBranchInsurance);
    let targetCombobox = this.state.comboboxList.health_insurance_types;
    switch (companyBranchInsurance.health_insurance_flag) {
      case EXISTANCE_EXCLUSION_FLAG.EXIST.ID:
        targetCombobox = filterComboBoxHealthInsuranceTypeWhenExist(
          this.state.comboboxList.health_insurance_types
        );
        break;
      case EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID:
        targetCombobox = filterComboBoxHealthInsuranceTypeWhenExclusion(
          this.state.comboboxList.health_insurance_types,
          companyBranchInsurance.health_insurance_reason_exclusion
        );
        break;
      default:
        break;
    }

    return setInputOrSelectionForType(
      newCompanyBranchInsurance,
      'health_insurance_type',
      targetCombobox
    );
  };

  setOtherStateByPensionInsurance = companyBranchInsurance => {
    let newCompanyBranchInsurance = _.cloneDeep(companyBranchInsurance);
    let targetCombobox = this.state.comboboxList.pension_insurance_types;
    switch (companyBranchInsurance.pension_flag) {
      case EXISTANCE_EXCLUSION_FLAG.EXIST.ID:
        targetCombobox = filterComboBoxPensionInsuranceTypeWhenExist(
          this.state.comboboxList.pension_insurance_types
        );
        newCompanyBranchInsurance = setInputOrSelectionForType(
          newCompanyBranchInsurance,
          'pension_type',
          targetCombobox
        );
        return newCompanyBranchInsurance;
      case EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID:
        targetCombobox = filterComboBoxPensionInsuranceTypeWhenExclusion(
          this.state.comboboxList.pension_insurance_types,
          companyBranchInsurance.pension_type
        );
        newCompanyBranchInsurance = setInputOrSelectionForType(
          newCompanyBranchInsurance,
          'pension_type',
          targetCombobox
        );
        newCompanyBranchInsurance = setInputOrSelectionForReasonExclusion(
          newCompanyBranchInsurance,
          'pension_reason_exclusion',
          this.state.comboboxList.pension_insurance_exclusions
        );
        return newCompanyBranchInsurance;
      default:
        break;
    }

    return newCompanyBranchInsurance;
  };

  setOtherStateByEmploymentInsurance = companyBranchInsurance => {
    let newCompanyBranchInsurance = _.cloneDeep(companyBranchInsurance);
    let targetCombobox = this.state.comboboxList
      .employment_insurance_exclusions;
    switch (companyBranchInsurance.employment_insurance_flag) {
      case EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID:
        targetCombobox = this.state.comboboxList
          .employment_insurance_exclusions;
        newCompanyBranchInsurance = setInputOrSelectionForReasonExclusion(
          newCompanyBranchInsurance,
          'employment_insurance_reason_exclusion',
          targetCombobox
        );
        return newCompanyBranchInsurance;
      default:
        break;
    }
    return newCompanyBranchInsurance;
  };

  resetClearColumnWhenHealthInsuranceStatus = () => {
    const { company_branch_insurance } = this.state.formValues;
    const companyBranchInsurance = this.setOtherStateByHealthInsurance(
      company_branch_insurance
    );
    this.setState({
      formValues: {
        ...this.state.formValues,
        company_branch_insurance: {
          ...companyBranchInsurance,
        },
      },
    });
  };

  //regional_development_bureau_idは""の場合、APIにnullを送る
  setEmptyRegionalDevelopmentBureauIdToNull = companyBranchPermissions => {
    const result = companyBranchPermissions.map(item => {
      if (showPrefectureInput(item.permitted_source_section)) {
        if (
          item.regional_development_bureau_id === '' ||
          item.regional_development_bureau_id === undefined ||
          !showRegionalDevelopmentBureau(item.prefectures_code_id)
        ) {
          item.regional_development_bureau_id = null;
        }
      } else {
        item.regional_development_bureau_id = null;
        item.prefectures_code_id = null;
      }
      return item;
    });
    return result;
  };

  handleCompanyBranchPermission = (value, isCreate) => {
    const company_branch_permissions = _.cloneDeep(
      this.state.formValues.company_branch_permissions
    );
    if (isCreate) {
      company_branch_permissions.push(value);
    } else {
      _.forEach(company_branch_permissions, (item, index) => {
        if (_.get(item, 'id') === _.get(value, 'id')) {
          company_branch_permissions[index] = value;
          return false;
        }
      });
    }
    this.setState(
      {
        formValues: {
          ...this.state.formValues,
          company_branch_permissions,
        },
      },
      () => this.validate('company_detail')
    );
  };

  handleDeleteCompanyBranchPermission = (id, isCreate) => {
    let company_branch_permissions = _.cloneDeep(
      this.state.formValues.company_branch_permissions
    );
    let delete_company_branch_permission_group_ids = _.cloneDeep(
      this.state.formValues.delete_company_branch_permission_group_ids
    );
    const deletedCompanyBranchPermissionGroups = _.remove(
      company_branch_permissions,
      item => _.get(item, 'id') === id
    );
    let deletedCompanyBranchPermissionIds = [];
    if (!isCreate) {
      delete_company_branch_permission_group_ids = [
        ...delete_company_branch_permission_group_ids,
        id,
      ];
      deletedCompanyBranchPermissionIds = _.flatMap(
        deletedCompanyBranchPermissionGroups,
        'company_branch_permissions'
      )
        .filter(
          permission =>
            !!permission.id && permission._destroy !== EXISTANCE_FLAG.EXIST.ID
        )
        .map(permission => permission.id);
    }
    this.handleDeletePermissionExistGreenFile(
      deletedCompanyBranchPermissionIds,
      () =>
        this.setState(
          {
            formValues: {
              ...this.state.formValues,
              company_branch_permissions,
              delete_company_branch_permission_group_ids,
            },
          },
          () => this.validate('company_detail')
        )
    );
  };

  download = async fileId => {
    attachDocumentCompanyDownload(
      () => {
        this.setState({
          visibleDialogFlag: true,
        });
      },
      this.selectedCompanyId,
      fileId
    );
  };

  closeError = () => {
    this.setState({
      visibleDialogFlag: false,
    });
  };

  handleValidateCompanyBranchPermission = () => {
    const {
      formValues: { company_branch_permissions, company_detail },
    } = this.state;
    const invalid = _.some(company_branch_permissions, 'invalid_flag');
    if (
      !isConstructionIndustryPermissionStatus(
        company_detail.construction_industry_permission_flag
      )
    ) {
      return true;
    }
    return !_.isEmpty(company_branch_permissions) && !invalid;
  };

  deleteOldCompanyPermissionDocuments = file => {
    attachDocumentDeleteState(
      this.state.formValues.old_company_permission_documents,
      documents => {
        this.setState(
          {
            formValues: {
              ...this.state.formValues,
              old_company_permission_documents: documents,
            },
          },
          () => {
            const deleteOldDocuments = _.cloneDeep(
              this.state.formValues
                .delete_company_branch_permission_document_ids
            );
            deleteOldDocuments.push(_.get(file, 'id'));
            this.setState({
              formValues: {
                ...this.state.formValues,
                delete_company_branch_permission_document_ids: deleteOldDocuments,
              },
            });
          }
        );
      },
      file
    );
  };

  render() {
    const {
      isLoading,
      selectedCompanyName,
      partnerCompanyBranch,
      formValues,
      errorMessages,
      comboboxList,
      checkboxList,
      ccusformValues,
      companyDocuments,
      documentCodes,
      dialogStatus,
      validate,
      confirmationModalSafetyDocItem,
    } = this.state;
    const title = `${selectedCompanyName} 会社情報`;
    const masterSlideViewBodyHeight = safariOnIosCheck()
      ? 'calc(100vh - 115px)'
      : 'calc(100vh - 84px)';

    return (
      <React.Fragment>
        <div
          id='slide-view'
          className='contruction-slide-view show PartnerCompanyBranchSafetyEdit'
        >
          <Helmet>
            <title>
              {HEADER_CONSTANTS.title} - {title}
            </title>
          </Helmet>
          <div className='contruction-slide-view__view'>
            <MasterPageHeader
              loaded={!isLoading}
              loaderComponent={<ClipLoader size={20} color='#EDB715' />}
              title={title}
              onClose={() => this.events.dialog.goBack()}
            />
            <div
              className='contruction-slide-view__body contruction-slide-view__body--height-fix'
              style={{ height: masterSlideViewBodyHeight }}
            >
              <div className='contruction-detail-view'>
                <div className='contruction-detail-view__sidemenu'>
                  <PartnerNaviList
                    isSelectedPartnerCompanyBranchSafetyPreview={true}
                    isEditable={true}
                    selectedPartnerCompanyId={this.selectedCompanyId}
                    expirationCompany={this.state.expirationCompany}
                  />
                </div>
                <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                  <div className='contruction-detail-view__menu'>
                    <span className='construction-detail-view__button'>
                      <button
                        className='btn--sub'
                        onClick={() => this.events.dialog.goBack()}
                      >
                        編集をやめる
                      </button>
                    </span>
                    <span className='construction-detail-view__button'>
                      <button
                        className={
                          !_.isEmpty(errorMessages) || validate.invalid
                            ? 'btn--effective btn--disabled'
                            : 'btn--effective'
                        }
                        onClick={() => {
                          if (!validate.invalid) {
                            this.events.form.submit();
                          }
                        }}
                        data-testid='submit-btn'
                      >
                        更新
                      </button>
                    </span>
                    <span className='construction-detail-view__multiple-alert-text'>
                      {!_.isEmpty(errorMessages) || validate.invalid
                        ? messageUtility.getMessage('E-000-014')
                        : null}
                    </span>
                    {!!this.state.requiredInput.total && (
                      <div className='contruction-detail-view__end-item'>
                        {`必須項目の入力数 ${this.state.requiredInput.count}/${
                          this.state.requiredInput.total
                        }`}
                      </div>
                    )}
                  </div>
                  <div className='contruction-detail-view__bar' />
                  <PartnerCompanyBranchSafetyForm
                    values={formValues}
                    messages={errorMessages}
                    checkboxList={checkboxList}
                    comboboxList={comboboxList}
                    ccusformValues={ccusformValues}
                    events={this.events.form}
                    companyDocuments={companyDocuments}
                    documentCodes={documentCodes}
                    findStatusFn={this.findStatus}
                    partnerCompanyBranch={partnerCompanyBranch}
                    bureaux={this.state.bureaux}
                    attentionBox={
                      hasRequestUserFixList({
                        requestUserFixListByHealthInsurance: this.state
                          .requestUserFixListByHealthInsurance,
                        requestUserFixListByPensionInsurance: this.state
                          .requestUserFixListByPensionInsurance,
                        requestUserFixListByEmploymentInsurance: this.state
                          .requestUserFixListByEmploymentInsurance,
                      }) && (
                        <div
                          style={{
                            maxWidth: '960px',
                            marginBottom: '24px',
                          }}
                        >
                          <AttentionBox
                            flags={this.state.initialLoadingSocialInsuranceFlag}
                            healthInsuranceData={
                              this.state.requestUserFixListByHealthInsurance
                            }
                            pensionData={
                              this.state.requestUserFixListByPensionInsurance
                            }
                            employmentData={
                              this.state.requestUserFixListByEmploymentInsurance
                            }
                          />
                        </div>
                      )
                    }
                    handleCompanyBranchPermission={
                      this.handleCompanyBranchPermission
                    }
                    eventCompanyBranchPermissionCommon={
                      this.eventCompanyBranchPermissionCommon
                    }
                    selectedCompanyId={this.selectedCompanyId}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 安全書類項目確認のダイアログ */}
        <ConfirmationSafetyDocItemDialog
          rootClassName={Style.safetyDocItemErrorDialog}
          visible={
            dialogStatus === DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id
          }
          errorPropertyList={confirmationModalSafetyDocItem.errorPropertyList}
          onConfirm={() => {
            this.updatingFlag = false;
            this.events.form.submit();
          }}
          onCancel={() => {
            this.onCloseSafetyDocItemErrorDialog();
            this.updatingFlag = false;
          }}
        />
        <Information
          title={
            <div className='PartnerCompanyBranchSafetyPreview__infor'>
              <i className='icon-error' />
              <p>エラーが発生しました。</p>
            </div>
          }
          message='指定されたファイルが存在しません。'
          buttonText={messageUtility.getMessage('I-000-017')}
          visible={this.state.visibleDialogFlag}
          onClose={this.closeError}
          multilineText
        />
        <DeleteCompanyLicenseConfirmDialog
          visible={this.state.visibleConfirmDeleteDialog}
          data={this.state.deleteCompanyBranchPermissionsExistGreenFile}
          bureaux={this.state.bureaux}
          onConfirm={this.confirmDeleteDialogFn}
          onCancel={() => {
            this.updatingFlag = false;
            this.setState({ visibleConfirmDeleteDialog: false });
          }}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PartnerCompanyBranchSafetyEdit.jsx